// Updated CabinetZdoRequests.jsx
import React, { useState, useEffect, useMemo } from 'react';
import './cabinet-zdo-requests.css';
import { zdoRequestsApi } from './actions';
import arrow_down_fill_svg from '../../../../../img/arrow-down-fill.svg';


const getRequestsStr = (n) => `${n} ${(n % 10 === 1 && n % 100 !== 11) ? 'заявка' : ([2, 3, 4].includes(n % 10) && ![12, 13, 14].includes(n % 100)) ? 'заявки' : 'заявок'}`;


const CabinetZdoRequests = ({ kg_id, min_age = 0, isHead = false, acceptChildren = ()=>{}, isModerator = false, detailInfo = ()=>{} }) => {
  const MAX_AGE = 8;
  
  const [activeYearTab, setActiveYearTab] = useState('');
  const [ageGroups, setAgeGroups] = useState([]);
  const [expandedGroups, setExpandedGroups] = useState({});
  const [requestsData, setRequestsData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [showWithoutDeferred, setShowWithoutDeferred] = useState(false);
  const [allRequests, setAllRequests] = useState({});
  const [userHasRequests, setUserHasRequests] = useState(false);
  const [userRequestsCount, setUserRequestsCount] = useState(0);
  const [periods, setPeriods] = useState([]);
  const [allYearsData, setAllYearsData] = useState({});
  const [expandedYears, setExpandedYears] = useState({});
  const [benefitsList, setBenefitList] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [ageBrackets, setAgeBrackets] = useState([]); // <-- додати

  const createAgeGroups = (minAge, maxAge) => {
    const groups = [];
    let currentAge = minAge;
    
    if (minAge === 1.5) {
      groups.push({
        id: '1.5-2',
        title: 'Вікова група від 1 року 6 місяців до 2 років',
        minAge: 1.5,
        maxAge: 2
      });
      currentAge = 2;
    }
    
    while (currentAge < maxAge) {
      const nextAge = currentAge + 1;
      const groupId = `${currentAge}-${nextAge}`;
      
      let groupTitle;
      if (currentAge === 1) {
        groupTitle = `Вікова група від ${currentAge} до ${nextAge} року`;
      } else if (currentAge >= 2 && currentAge <= 4) {
        groupTitle = `Вікова група від ${currentAge} до ${nextAge} років`;
      } else {
        groupTitle = `Вікова група від ${currentAge} до ${nextAge} років`;
      }
      
      groups.push({
        id: groupId,
        title: groupTitle,
        minAge: currentAge,
        maxAge: nextAge
      });
      
      currentAge = nextAge;
    }
    
    return groups;
  };

  // Функция для добавления порядковых номеров к заявкам в группе
  const addOriginalIndicesToGroup = (requests) => {
    // Сортируем по queueNumber (чем меньше номер, тем выше позиция)
    const sortedRequests = [...requests].sort((a, b) => {
      const queueA = a.queueNumber || Number.MAX_SAFE_INTEGER;
      const queueB = b.queueNumber || Number.MAX_SAFE_INTEGER;
      return queueA - queueB;
    });
    
    // Добавляем порядковый номер (начиная с 1)
    return sortedRequests.map((request, idx) => ({
      ...request,
      originalIndex: idx + 1
    }));
  };

  // Функция фильтрации заявок по поисковому запросу с сохранением порядковых номеров
  const filterRequestsBySearch = (requests, query) => {
    if (!query.trim()) return requests;
    
    const lowerQuery = query.toLowerCase().trim();
    
    const filtered = {};
    Object.keys(requests).forEach(groupId => {
      // Сначала фильтруем заявки, но сохраняем originalIndex
      filtered[groupId] = requests[groupId].filter(request => 
        request.name?.toLowerCase().includes(lowerQuery) ||
        request.cert?.toLowerCase().includes(lowerQuery) ||
        request.additional?.toLowerCase().includes(lowerQuery)
      );
    });
    
    // Удаляем пустые группы
    Object.keys(filtered).forEach(groupId => {
      if (filtered[groupId].length === 0) {
        delete filtered[groupId];
      }
    });
    
    return filtered;
  };

  const bracketTitle = (b) => {
    const fmt = (val) => {
        const years = Math.floor(val);
        const months = Math.round((val - years) * 12);
        if (months === 0) return `${years}`;
        return `${years} р. ${months} міс.`;
    };
    return `Вікова категорія від ${fmt(b.from)} до ${fmt(b.to)} років`;
  };

  // Функция фильтрации для структуры allYearsData
  const filterAllYearsDataBySearch = (yearsData, query) => {
    if (!query.trim()) return yearsData;
    
    const lowerQuery = query.toLowerCase().trim();
    const filtered = {};
    
    Object.keys(yearsData).forEach(year => {
      const yearGroups = yearsData[year];
      const filteredYearGroups = {};
      
      Object.keys(yearGroups).forEach(ageKey => {
        const filteredRequests = yearGroups[ageKey].filter(request =>
          request.name?.toLowerCase().includes(lowerQuery) ||
          request.cert?.toLowerCase().includes(lowerQuery) ||
          request.additional?.toLowerCase().includes(lowerQuery)
        );
        
        if (filteredRequests.length > 0) {
          filteredYearGroups[ageKey] = filteredRequests;
        }
      });
      
      if (Object.keys(filteredYearGroups).length > 0) {
        filtered[year] = filteredYearGroups;
      }
    });
    
    return filtered;
  };

  const loadBenefits = async () => {
    const benList = await zdoRequestsApi.getBenefitsInfo();
    if(benList.length > 0) setBenefitList(benList); 
  }

  useEffect(() => {
    const groups = createAgeGroups(min_age, MAX_AGE);
    setAgeGroups(groups);
    
    const initialExpandedState = {};
    groups.forEach(group => {
      initialExpandedState[group.id] = true;
    });
    setExpandedGroups(initialExpandedState);
  }, [min_age]);

  useEffect(()=>{
    const speriods = async ()=>{
      const p_arr = await zdoRequestsApi.getPeriodsActive();
      setPeriods(p_arr);
      if(p_arr[0]) setActiveYearTab(p_arr[0]);
      if(p_arr[0]) loadRequests(p_arr[0]);
    }

    speriods();
    loadBenefits();
  },[])

  const toggleGroup = (groupId) => {
    setExpandedGroups(prev => ({
      ...prev,
      [groupId]: !prev[groupId]
    }));
  };

  const toggleYear = (year) => {
    setExpandedYears(prev => ({
      ...prev,
      [year]: !prev[year]
    }));
  };

  const handleYearTabClick = (tab) => {
    setActiveYearTab(tab);
    setSearchQuery('');
    if (tab === 'all') setAgeBrackets([]); // <-- додати
    loadRequests(tab);
  };

  const isDeferredRequest = (request) => {
    if (!request.preferDateFrom) {
      return false;
    }
    
    const preferDate = new Date(request.preferDateFrom);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    return preferDate > today;
  };

  const filterDeferredRequests = (requests) => {
    if (!showWithoutDeferred) {
      return requests;
    }
    
    const filtered = {};
    Object.keys(requests).forEach(groupId => {
      filtered[groupId] = requests[groupId].filter(request => 
        !isDeferredRequest(request)
      );
    });
    
    return filtered;
  };

  const getTotalCountAfterFilter = (filteredRequests) => {
    return Object.values(filteredRequests).reduce((total, groupRequests) => 
      total + groupRequests.length, 0
    );
  };
  
  const countUserRequests = (requests) => {
    return Object.values(requests).reduce((total, groupRequests) => 
      total + groupRequests.filter(request => request.isMyRequest).length, 0
    );
  };

  const loadRequests = async (period = 'all') => {
      try {
          setLoading(true);
          setError(null);

          if (period === 'all') {
              // Вкладка "Наступні": один виклик бека, який сам формує
              // список одразу по всіх майбутніх навчальних роках і
              // проставляє кожній заявці рік (_periodYear).
              const startYear = periods.length > 0 ? Math.max(...periods) + 1 : new Date().getFullYear();

              const allYearsResponse = await zdoRequestsApi.getFutureQueueListAll(kg_id, startYear);

              const transformedByYear = {};
              (allYearsResponse.years || []).forEach(yearEntry => {
                  const yearNum = parseInt(yearEntry.academicYear, 10); // "2027/2028" -> 2027

                  const { grouped } = zdoRequestsApi.transformQueueListToGroups(
                      yearEntry, [], benefitsList, kg_id
                  );

                  const yearGroups = {};
                  Object.keys(grouped).forEach(ageKey => {
                      yearGroups[ageKey] = addOriginalIndicesToGroup(grouped[ageKey]);
                  });

                  transformedByYear[yearNum] = yearGroups;
              });

              setAllYearsData(transformedByYear);
              const initYears = {};
              Object.keys(transformedByYear).forEach(y => { initYears[y] = true; });
              setExpandedYears(initYears);
              setTotalCount(allYearsResponse.totalRequests || 0);
              // Наразі бек для "Наступні" не повертає myRequests — свою заявку тут не позначаємо
              setUserRequestsCount(0);
              setUserHasRequests(false);

      } else {
          const queueListResponse = await zdoRequestsApi.getQueueList(
              kg_id,
              period,
              { languageTraining: undefined, preferDateBefore: undefined }
          );

          setAgeBrackets(queueListResponse.ageBrackets || []); // <-- додати

          const myRequestsIds = [];
          const { grouped } = zdoRequestsApi.transformQueueListToGroups(
              queueListResponse, myRequestsIds, benefitsList, kg_id
          );

          const transformedData = {};
          Object.keys(grouped).forEach(groupId => {
              transformedData[groupId] = addOriginalIndicesToGroup(grouped[groupId]);
          });

          setAllRequests(transformedData);
          const filteredData = filterDeferredRequests(transformedData);
          setRequestsData(filteredData);
          setTotalCount(getTotalCountAfterFilter(filteredData));
          setUserRequestsCount(myRequestsIds.length);
          setUserHasRequests(myRequestsIds.length > 0);

          const initialExpanded = {};
          Object.keys(transformedData).forEach(id => { initialExpanded[id] = true; });
          setExpandedGroups(initialExpanded);
      }

      } catch (err) {
          console.error('Error loading requests:', err);
          setError(err.message);
      } finally {
          setLoading(false);
      }
  };

  const handleToggleDeferred = (event) => {
    const isChecked = event.target.checked;
    setShowWithoutDeferred(isChecked);
    
    const filteredData = filterDeferredRequests(allRequests);
    setRequestsData(filteredData);
    
    setTotalCount(getTotalCountAfterFilter(filteredData));
    const userRequestsCount = countUserRequests(filteredData);
    setUserRequestsCount(userRequestsCount);
    setUserHasRequests(userRequestsCount > 0);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const groupRequestsByDynamicAge = (requests, minAge, maxAge) => {
    const groups = {};
    
    const allGroups = createAgeGroups(minAge, maxAge);
    allGroups.forEach(group => {
      groups[group.id] = [];
    });

    requests.forEach(request => {
      const requestAge = request.ageLimitFrom || 0;
      
      for (let i = 0; i < allGroups.length; i++) {
        const group = allGroups[i];
        
        if (group.id === '1.5-2') {
          if (requestAge >= 1.5 && requestAge < 2) {
            groups[group.id].push(request);
            break;
          }
        } else {
          if (requestAge >= group.minAge && requestAge < group.maxAge) {
            groups[group.id].push(request);
            break;
          }
        }
      }
    });

    // Сортировка по queueNumber перед добавлением в группы
    Object.keys(groups).forEach(groupId => {
      groups[groupId].sort((a, b) => {
        const queueA = a.queueNumber || Number.MAX_SAFE_INTEGER;
        const queueB = b.queueNumber || Number.MAX_SAFE_INTEGER;
        return queueA - queueB;
      });
    });

    Object.keys(groups).forEach(groupId => {
      if (groups[groupId].length === 0) {
        delete groups[groupId];
      }
    });

    return groups;
  };

  // Получаем отфильтрованные данные для текущей вкладки
  const getFilteredDataForCurrentTab = () => {
    if (activeYearTab === 'all') {
      let filtered = allYearsData;
      
      if (searchQuery.trim()) {
        filtered = filterAllYearsDataBySearch(filtered, searchQuery);
      }
      
      const total = Object.values(filtered).reduce((s, yearGroups) =>
        s + Object.values(yearGroups).reduce((s2, arr) => s2 + arr.length, 0), 0
      );
      
      return { data: filtered, total };
    } else {
      let filtered = { ...requestsData };
      
      if (searchQuery.trim()) {
        filtered = filterRequestsBySearch(filtered, searchQuery);
      }
      
      const total = getTotalCountAfterFilter(filtered);
      
      return { data: filtered, total };
    }
  };

  const { data: currentFilteredData, total: currentTotal } = getFilteredDataForCurrentTab();

  const getStatusBadgeClass = (status) => {
    const statusClasses = {
      accepted: 'queuetable-status-badge-accepted',
      docs: 'queuetable-status-badge-docs',
      docsCur: 'queuetable-status-badge-docs',
      selection: 'queuetable-status-badge-pending',
      selectionCur: 'queuetable-status-badge-pending',
      deleted: 'queuetable-status-badge-deleted',
      pending: 'queuetable-status-badge-pending',
      waiting: 'queuetable-status-badge-waiting',
      'provide-doc': 'queuetable-status-badge-provide-doc',
      selected: 'queuetable-status-badge-selected',
      gathered: 'queuetable-status-badge-gathered',
      rejected: 'queuetable-status-badge-rejected'
    };
    return `queuetable-status-badge ${statusClasses[status] || ''}`;
  };

  const getStatusText = (status) => {
    const statusTexts = {
      accepted: 'Очікує на запрошення',
      docsKg: 'Надання документів до цього садочку',
      docs: 'Надання документів до іншого садочка',
      selection: 'Розглядає запрошення  до іншого садочка',
      selectionKg: 'Розглядає запрошення до цього садочку',
      deleted: 'Видалена',
    };
    return statusTexts[status] || status;
  };

  const getActionRequet = (request) => {
    if(isHead && request.acceptButton) return(<button className="btn btn-primary" onClick={()=>{ acceptChildren(request.id)} } >Зарахувати дитину</button>)
      if(isModerator || isHead) {return <strong className="link-like-strong" onClick={()=>detailInfo(request.id)}>Переглянути</strong>}
  }

  // Рендер строки с заявкой - используем originalIndex для отображения номера в очереди
  const renderRequestRow = (request, index, groupId) => {
    const rowClass = request.isMyRequest ? 'table-info' : '';
    
    return (
      <tr key={`${groupId}-${index}`} className={rowClass}>
        <td className="fw-semibold">
          {request.originalIndex}
          {/* Добавляем индикатор фильтрации, если номер отличается от позиции в отфильтрованном списке */}
          {false && searchQuery && request.originalIndex !== (index + 1) && (
            <span className="text-muted ms-1" style={{ fontSize: '0.7em' }}>
              (поз. {index + 1} у фільтрі)
            </span>
          )}
        </td>
        <td>
          {request.name}
          {request.isMyRequest && (
            <span 
              className="badge bg-primary ms-2" 
              title="Ваша заявка"
              style={{ fontSize: '0.7em' }}
            >
              ваша
            </span>
          )}
         </td>
        <td>{request.cert}</td>
        <td>{request.submitted}</td>
        <td>{request.sendFrom}</td>
        <td>
          <span className={getStatusBadgeClass(request.status)}>
            {getStatusText(request.status)}
          </span>
         </td>
        <td className="text-truncate" style={{ maxWidth: '340px' }}>
          {request.additional}
         </td>
        <td className="queuetable-actions text-end">{getActionRequet(request)}</td>
      </tr>
    );
  };

  // Рендер группы для обычных вкладок
  const renderGroup = (groupId, groupTitle) => {
    const isExpanded = expandedGroups[groupId];
    const groupRequests = currentFilteredData[groupId] || [];

    if (groupRequests.length === 0) {
      return null;
    }

    return (
      <React.Fragment key={groupId}>
        <tr className="queuetable-group-row" data-group={groupId}>
          <td colSpan="8">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center gap-2">
                <button
                  className="btn btn-sm btn-link queuetable-collapse-toggle"
                  type="button"
                  aria-label="toggle"
                  aria-expanded={isExpanded}
                  onClick={() => toggleGroup(groupId)}
                >
                  <img src={arrow_down_fill_svg} alt="" />
                </button>
                <div className="queuetable-group-title">
                  {groupTitle}
                  <span className="queuetable-group-count ms-2">({groupRequests.length})</span>
                </div>
              </div>
              <div className="dropdown">
                <button
                  className="btn btn-link p-0 text-body"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  aria-label="Опції групи"
                >
                  <i className="fa-solid fa-ellipsis-vertical"></i>
                </button>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <a className="dropdown-item" href="#">
                      Сортувати за датою
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Сортувати за іменем
                    </a>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      Експорт CSV
                    </a>
                  </li>
                </ul>
              </div>
            </div>
           </td>
         </tr>
        {isExpanded && groupRequests.map((request, index) => 
          renderRequestRow(request, index, groupId)
        )}
      </React.Fragment>
    );
  };

  // Рендер двухуровневой структуры для вкладки "Наступні"
  const renderAllYears = () => {
    const years = Object.keys(currentFilteredData)
      .filter(y => !periods.includes(+y))
      .sort((a, b) => +a - +b);
    
    if (years.length === 0) {
      return (
        <tr>
          <td colSpan="8" className="text-center py-4 text-muted">
            {searchQuery ? 'Нічого не знайдено за вашим запитом' : 'Немає заявок'}
           </td>
        </tr>
      );
    }

    return years.map(year => {
      const isYearExpanded = expandedYears[year] !== false;
      const yearGroups = currentFilteredData[year];
      const yearTotal = Object.values(yearGroups).reduce((s, arr) => s + arr.length, 0);

      return (
        <React.Fragment key={`year-${year}`}>
          <tr className="queuetable-year-group-row">
            <td colSpan="8">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-2">
                  <button
                    className="btn btn-sm btn-link queuetable-collapse-toggle"
                    type="button"
                    aria-label="toggle year"
                    aria-expanded={isYearExpanded}
                    onClick={() => toggleYear(year)}
                  >
                    <img
                      src={arrow_down_fill_svg}
                      alt=""
                      style={{ transform: isYearExpanded ? 'rotate(0deg)' : 'rotate(-90deg)', transition: 'transform .2s' }}
                    />
                  </button>
                  <div className="queuetable-year-group-title">
                    Навчальний рік {year}–{+year + 1}
                    <span className="queuetable-group-count ms-2">({yearTotal})</span>
                  </div>
                </div>
              </div>
             </td>
           </tr>

          {isYearExpanded && Object.keys(yearGroups).sort((a, b) => {
            const [aMin] = a.split('-').map(Number);
            const [bMin] = b.split('-').map(Number);
            return aMin - bMin;
          }).map(ageKey => {
            const [ageFrom, ageTo] = ageKey.split('-').map(Number);
            const groupKey = `${year}-${ageKey}`;
            const isGroupExpanded = expandedGroups[groupKey] !== false;
            const groupRequests = yearGroups[ageKey];
            if (!groupRequests || groupRequests.length === 0) return null;

            const groupTitle = `Вікова група від ${ageFrom} до ${ageTo} ${ageTo <= 4 ? 'років' : 'років'}`;

            return (
              <React.Fragment key={groupKey}>
                <tr className="queuetable-group-row queuetable-group-row--nested" data-group={groupKey}>
                  <td colSpan="8">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center gap-2">
                        <button
                          className="btn btn-sm btn-link queuetable-collapse-toggle"
                          type="button"
                          aria-label="toggle group"
                          aria-expanded={isGroupExpanded}
                          onClick={() => toggleGroup(groupKey)}
                        >
                          <img
                            src={arrow_down_fill_svg}
                            alt=""
                            style={{ transform: isGroupExpanded ? 'rotate(0deg)' : 'rotate(-90deg)', transition: 'transform .2s' }}
                          />
                        </button>
                        <div className="queuetable-group-title">
                          {groupTitle}
                          <span className="queuetable-group-count ms-2">({groupRequests.length})</span>
                        </div>
                      </div>
                      <div className="dropdown">
                        <button
                          className="btn btn-link p-0 text-body"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          aria-label="Опції групи"
                        >
                          <i className="fa-solid fa-ellipsis-vertical"></i>
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end">
                          <li><a className="dropdown-item" href="#">Сортувати за датою</a></li>
                          <li><a className="dropdown-item" href="#">Сортувати за іменем</a></li>
                          <li><hr className="dropdown-divider" /></li>
                          <li><a className="dropdown-item" href="#">Експорт CSV</a></li>
                        </ul>
                      </div>
                    </div>
                    </td>
                  </tr>
                {isGroupExpanded && groupRequests.map((request, index) =>
                  renderRequestRow(request, index, groupKey)
                )}
              </React.Fragment>
            );
          })}
        </React.Fragment>
      );
    });
  };

  if (loading) {
    return (
      <main className="queuetable-main-content queuetable-page">
        <div className="container-fluid">
          <div className="queuetable-content-wrapper">
            <div className="text-center py-5">
              <img src="/img/loading.gif" width="100px" alt="Loading..." />
            </div>
          </div>
        </div>
      </main>
    );
  }

  if (error) {
    return (
      <main className="queuetable-main-content queuetable-page">
        <div className="container-fluid">
          <div className="queuetable-content-wrapper">
            <div className="alert alert-danger">
              Помилка при завантаженні даних: {error}
            </div>
          </div>
        </div>
      </main>
    );
  }

  return (
    <main className="queuetable-main-content queuetable-page">
      <div className="container-fluid">
        <div className="queuetable-content-wrapper">
          <div className="queuetable-toolbar-line">
            <div className="queuetable-left d-flex align-items-center gap-2 flex-wrap">
              <div className="dropdown">
                {false && <button
                  className="btn btn-outline-secondary btn-sm dropdown-toggle queuetable-filters-btn"
                  type="button"
                  id="queuetableFiltersBtn"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Фільтри не застосовані
                </button>}
                <div className="dropdown-menu p-3" style={{ minWidth: '280px' }}>
                  <div className="mb-2 small text-muted">Статус заявки</div>
                  <div className="form-check mb-1">
                    <input className="form-check-input queuetable-filter-status" type="checkbox" value="accepted" id="queuetableFAccepted" defaultChecked />
                    <label className="form-check-label" htmlFor="queuetableFAccepted">Прийнята</label>
                  </div>
                  <div className="form-check mb-1">
                    <input className="form-check-input queuetable-filter-status" type="checkbox" value="docs" id="queuetableFDocs" defaultChecked />
                    <label className="form-check-label" htmlFor="queuetableFDocs">Надання документів</label>
                  </div>
                  <div className="form-check mb-1">
                    <input className="form-check-input queuetable-filter-status" type="checkbox" value="selection" id="queuetableFSelection" defaultChecked />
                    <label className="form-check-label" htmlFor="queuetableFSelection">Обрання садочків</label>
                  </div>
                  <div className="form-check mb-2">
                    <input className="form-check-input queuetable-filter-status" type="checkbox" value="deleted" id="queuetableFDeleted" defaultChecked />
                    <label className="form-check-label" htmlFor="queuetableFDeleted">Видалена</label>
                  </div>
                  <div className="d-flex justify-content-between pt-2 border-top">
                    <button className="btn btn-link btn-sm text-decoration-none" id="queuetableFiltersReset" type="button">
                      Скинути
                    </button>
                    <button className="btn btn-primary btn-sm" id="queuetableFiltersApply" type="button">
                      Застосувати
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="queuetable-right d-flex align-items-center gap-3 flex-wrap">
              <div className="queuetable-search-box position-relative">
                <input
                  id="queuetableRequestsSearch"
                  type="text"
                  className="form-control queuetable-search-input"
                  placeholder="Швидкий пошук (ім'я, свідоцтво)"
                  aria-label="Швидкий пошук"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
                <i className="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
              </div>
            </div>
          </div>

          <div className="queuetable-year-bar d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-3 flex-wrap">
              <span className="queuetable-label text-white-50">Навчальний  рік</span>
              <ul className="queuetable-year-tabs nav nav-tabs">
                {periods.map(period => (
                  <li className="nav-item" key={period}>
                    <a
                      className={`nav-link ${activeYearTab === period ? 'active' : ''}`}
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleYearTabClick(period);
                      }}
                    >
                      {period}-{period + 1}
                    </a>
                  </li>
                ))}
                <li className="nav-item">
                  <a
                    className={`nav-link ${activeYearTab === 'all' ? 'active' : ''}`}
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleYearTabClick('all');
                    }}
                  >
                    Наступні
                  </a>
                </li>
              </ul>
            </div>
            {false && <div className="queuetable-switch-wrap d-flex align-items-center gap-2">
              <span className="text-white-50">Показувати без відтермінованих</span>
              <div className="form-check form-switch m-0">
                <input 
                  className="form-check-input" 
                  type="checkbox" 
                  id="queuetableNoDeferred" 
                  checked={showWithoutDeferred}
                  onChange={handleToggleDeferred}
                />
              </div>
            </div>}
          </div>

          {/* Информация о заявках пользователя */}
          {userHasRequests && (
            <div className="alert alert-info mb-4">
              <div className="d-flex align-items-center">
                <i className="fa-solid fa-circle-info me-2"></i>
                <div>
                  <strong>Ваша заявка у цьому навчальному році:</strong> У цьому списку є {userRequestsCount} ваших 
                  {userRequestsCount === 1 ? ' заявка' : 
                   userRequestsCount >= 2 && userRequestsCount <= 4 ? ' заявки' : 
                   ' заявок'}. Вони позначені блакитним кольором та міткою "ваша".
                </div>
              </div>
            </div>
          )}

          {/* Информация о результатах поиска */}
          {searchQuery && (
            <div className="alert alert-secondary mb-4">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <i className="fa-solid fa-search me-2"></i>
                  Результати пошуку для запиту: <strong>"{searchQuery}"</strong> — знайдено {currentTotal} заявок
                </div>
                <button 
                  className="btn btn-sm btn-outline-secondary" 
                  onClick={() => setSearchQuery('')}
                >
                  Очистити пошук
                </button>
              </div>
            </div>
          )}

          <div className="card queuetable-table-card">
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table queuetable-table align-middle mb-0">
                  <thead>
                    <tr>
                      <th style={{ maxWidth: "10px" }}>№</th>
                      <th>Ім'я дитини</th>
                      <th style={{ width: '160px' }}>Свідоцтво</th>
                      <th style={{ width: '140px' }}>Дата заявки</th>
                      <th style={{ width: '140px' }}>Надсилати з:</th>
                      <th style={{ width: '140px' }}>Статус</th>
                      <th>Додатково</th>
                      <th style={{ width: '80px' }}>Дії</th>
                    </tr>
                  </thead>
                  <tbody>
                    {activeYearTab === 'all'
                        ? renderAllYears()
                        : ageBrackets.length > 0
                            ? ageBrackets.map(b => renderGroup(
                                `${b.from}-${b.to}`,
                                bracketTitle(b)
                              ))
                            : ageGroups.map(group => renderGroup(group.id, group.title))
                    }
                  </tbody>
                </table>
              </div>

              <div className="d-flex align-items-center mt-4 queuetable-pagination-wrapper">
                <div className="queuetable-pagination-info">
                  Всього {getRequestsStr(currentTotal)}
                  {userHasRequests && (
                    <span className="text-primary ms-2">
                      (з них {userRequestsCount} ваших)
                    </span>
                  )}
                  {searchQuery && currentTotal === 0 && (
                    <span className="text-muted ms-2">
                      (спробуйте змінити пошуковий запит)
                    </span>
                  )}
                  {searchQuery && (
                    <span className="text-muted ms-2">
                      (номери в черзі відповідають реальній позиції в черзі)
                    </span>
                  )}
                </div>
                {false && <nav aria-label="Page navigation">
                  <ul className="pagination">
                    <li className="page-item">
                      <a className="page-link" href="#" aria-label="Previous">
                        <span aria-hidden="true">&lt;</span>
                      </a>
                    </li>
                    <li className="page-item active">
                      <a className="page-link" href="#">1</a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#">2</a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#">3</a>
                    </li>
                    <li className="page-item">
                      <a className="page-link" href="#" aria-label="Next">
                        <span aria-hidden="true">&gt;</span>
                      </a>
                    </li>
                  </ul>
                </nav>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default CabinetZdoRequests;